
import { useEffect, useState } from "react";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import { BiDetail } from 'react-icons/bi'
import SectionWrapper from "components/wrappers/SectionWrapper";
import Input from "components/forms/Input";
import Language from "components/Language";
import PropTypes from 'prop-types';

const MenuOptionDetails = ({ disabled, data }) => {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [isOpen])


    return (
        <>
            <button disabled={!!disabled}
                className={`capitalize focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  p-2 text-xl ${disabled ? 'bg-gray-200 text-gray-400' : ' text-blue-500 focus:ring-blue-200 hover:bg-blue-200'}`}
                onClick={() => setIsOpen(true)}>
                <BiDetail />
            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
                title={t('form.menu') + " " + t('form.details')}
            >
                <div className="w-[480px]  lg:w-[720px]">


                    {/* Question */}

                    <div className="flex justify-between">
                        <SectionWrapper
                            title={t('form.image_url')}
                            className="border-b flex-1 space-x-2"
                        >
                            <Input
                                defaultValue={data?.image_url}
                                disabled={true}
                            />
                        </SectionWrapper>
                        <SectionWrapper
                            title={t('form.status')}
                            className="border-b  space-x-2"
                        >
                            <span className="text-sm ">
                                {data?.enabled ? "Enabled" : "Disabled"}
                            </span>
                        </SectionWrapper>
                    </div>


                    <SectionWrapper
                        title={t('form.title')}
                        className="border-b"

                    >

                        <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="fr" />
                            <span className="mx-2">  {data?.french?.title}</span>
                        </div>

                        <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="ar" />
                            <span className="mx-2">  {data?.arabic?.title}</span>
                        </div>
                        {/* <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="drj" />
                            {data?.arabic_dialect_ma?.title}
                        </div> */}

                        <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="en" />
                            <span className="mx-2"> {data?.english?.title} </span>
                        </div>
                    </SectionWrapper>

                    <SectionWrapper
                        title={t('form.subtitle')}
                        className="border-b"

                    >
                        <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="fr" />
                            <span className="mx-2">  {data?.french?.subtitle}</span>
                        </div>
                        <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="ar" />
                            <span className="mx-2">  {data?.arabic?.subtitle}</span>
                        </div>


                        {/* <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="drj" />
                            {data?.arabic_dialect_ma?.subtitle}
                        </div> */}

                        <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="en" />
                            <span className="mx-2">   {data?.english?.subtitle}</span>
                        </div>

                    </SectionWrapper>


                    <SectionWrapper
                        title={t('form.button_label')}
                        className="border-b"
                    >
                        <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="fr" />
                            <span className="mx-2">    {data?.french?.button_label}</span>
                        </div>
                        <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="ar" />
                            <span className="mx-2">  {data?.arabic?.button_label}</span>
                        </div>


                        {/* <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="drj" />
                            {data?.arabic_dialect_ma?.button_label}
                        </div> */}

                        <div className="flex items-baseline my-2 ">
                            <Language showKeyOnly _key="en" />
                            <span className="mx-2">  {data?.english?.button_label}</span>
                        </div>
                    </SectionWrapper>

                    <SectionWrapper
                        title={t('form.card_response')}
                    >
                        <div className="border-dashed border-2 rounded bg-gray-50"
                        >

                            <div className="flex items-baseline my-2 ">
                                <Language showKeyOnly _key="fr" />
                                <span className="mx-2">    &ldquo;{data?.french?.card_response} &rdquo;</span>
                            </div>
                            <div className="flex items-baseline my-2 ">
                                <Language showKeyOnly _key="ar" />
                                <span className="mx-2">   &ldquo;{data?.arabic?.card_response} &rdquo;</span>
                            </div>


                            {/* <div className="flex items-baseline my-2 ">
                                <Language showKeyOnly _key="drj" />
                                &ldquo;{data?.arabic_dialect_ma?.card_response} &rdquo;
                            </div> */}

                            <div className="flex items-baseline my-2 ">
                                <Language showKeyOnly _key="en" />
                                <span className="mx-2">   &ldquo;{data?.english?.card_response} &rdquo;</span>
                            </div>
                        </div>

                    </SectionWrapper>

                </div>

            </ModalWrapper>


        </>

    );

}

export default MenuOptionDetails;

MenuOptionDetails.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.object,
};

